'use client';

import { useEffect } from 'react';

/**
 * Adds one or more class names to <body> while this component is mounted,
 * removes them on unmount. Lets per-route Magento-style body classes
 * (e.g. cms-home, catalog-category-view) reach <body> from inside a route's
 * page.tsx, since Next.js App Router only renders <body> in root layout.
 *
 * Usage:
 *   <BodyClass className="cms-home" />            // single class
 *   <BodyClass className="cms-home cms-page" />  // multiple
 */
export function BodyClass({ className }: { className: string }) {
  useEffect(() => {
    const classes = className.trim().split(/\s+/).filter(Boolean);
    if (classes.length === 0) return;
    classes.forEach((c) => document.body.classList.add(c));
    return () => {
      classes.forEach((c) => document.body.classList.remove(c));
    };
  }, [className]);

  return null;
}
